module.exports = __webpack_public_path__ + "static/media/avatarPicture.5b62074d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatarPicture.jpeg
// module id = 775
// module chunks = 0